import React, { useEffect, useState } from "react";
import * as actionCreators from "./../../actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button, Modal, Offcanvas } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  faArrowsRotate,
  faUser,
  faUsers,
  faHouse,
  faBook,
  faFileArrowUp,
  faRightFromBracket,
  faChartColumn,
  faMagnifyingGlassDollar,
  faMapLocationDot,
  faCompass,
  faCode,
  faMagnifyingGlass,
  faBookOpenReader,
  faBookmark,
  faFileSignature,
  faGear,
  faDollarSign,
  faEnvelope,
  faBuilding,
  faAddressCard,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import "./styles.css";
import { adminLevel } from "../../utilities";
import { options, params, urladmin } from "../../actions/webServices";
import Inputs from "./../Inputs";
import axios from "axios";

function Navbar({
  user,
  nameCompany,
  logOut,
  resetData,
  company,
  empresas,
  titularData,
  logIn,
  setCodemp,
  resetStatics,
  sucursales,
  regions,
  infoCompany,
}) {
  const [menu, setMenu] = useState({ main: false, user: false });
  const [bodyModal, setBodyModal] = useState(() => {});
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [logoSrc, setLogoSrc] = useState("");
  const navigate = useNavigate();

  const handleBurger = () => setShow(true);

  const handleChange = async (emp) => {
    setCodemp(emp);
    const test = emp > 50;
    params.set("codemp", emp);
    params.set("opcpm", "ChangeEmp");
    await axios.post(urladmin, params, options).then((r) => {
      logIn({ user: user.email, password: user.password, test });
      resetStatics();
    });
  };

  const showMenu = (param) => {
    if (param === "user") {
      setMenu({ main: false, user: !menu.user });
    } else {
      setMenu({ main: !menu.main, user: false });
    }
  };

  const goTo = (page) => {
    navigate(page);
    handleClose();
  };

  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShow(false);
    setShowModal(false);
    setMessage("");
  };

  const goToHome = () => {
    const currentUrl = window.location.href;
    if (currentUrl.includes("/qs") && !user.token) {
      const verifyObj = () => {
        let allowed = 0;
        for (const prop in titularData) {
          if (titularData[prop] !== "") {
            allowed += 1;
          }
        }
        return allowed === 1;
      };

      if (!verifyObj()) {
        setMessage(`¿Desea volver a pantalla principal y perder sus datos?`);
        setBodyModal(
          <>
            <Button
              onClick={() => {
                resetData(user.token);
                handleClose();
                navigate("/");
              }}
              className="btn btn-danger"
            >
              Si, volver
            </Button>
            <Button onClick={handleClose} className="btn btn-primary">
              Cancelar
            </Button>
          </>
        );
        handleShow();
        return;
      }
    }
    resetData(user.token);
    handleClose();
    navigate("/");
  };

  const close = () => {
    navigate("");
    logOut();
  };

  useEffect(() => {
    let img = new Image();
    let src = "";

    if (
      user?.grupo &&
      (infoCompany?.codemp == 2 || infoCompany?.codemp == 52)
    ) {
      src = `${process.env.REACT_APP_BASE_URL}/assets/nav/grupos/${user.grupo}.png`;
    } else if (nameCompany && nameCompany.includes("MUS")) {
      src = `${process.env.REACT_APP_BASE_URL}/assets/nav/grupos/20.png`;
    } else if (nameCompany) {
      src = `${process.env.REACT_APP_BASE_URL}/assets/nav/${nameCompany}.png`;
    }

    img.src = src;
    img.onload = () => {
      setLogoSrc(src);
    };
    img.onerror = () => {
      setLogoSrc(`${process.env.REACT_APP_BASE_URL}/assets/nav/grupos/20.png`);
    };
  }, [user, nameCompany]);

  return (
    <>
      <div
        className={`d-flex justify-content-between p-3 color-navbar m-0 scroll-off height-navbar`}
      >
        <div className="left d-flex align-items-center cursor-navbar">
          <div className="" onClick={goToHome}>
            <img
              src={logoSrc}
              className="logo ms-2"
              alt="Logo de la compañía"
            />
            {user.test && (
              <div className="d-flex w-100 justify-content-end align-items-center left scroll-off">
                <p className="m-0 mt-1 font-navbar fw-bold font-test">
                  Modo Test
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="d-flex align-items-center pt-2 right scroll-off">
          <div
            className="user mx-3 hidden-div"
            onClick={() => showMenu("user")}
          >
            <div className="d-flex align-items-center m-0 scroll-off hidden-div">
              {!user?.grupo && !nameCompany?.includes("MUS") && (
                <div className="d-flex align-items-center m-0 scroll-off">
                  <FontAwesomeIcon
                    className="mx-2 fs-6 font-navbar"
                    icon={faEnvelope}
                  />
                  <p
                    className="m-0 font-size-navbar pe-3 custom-border-right font-navbar scroll-off"
                    onClick={() => goTo("/profile")}
                  >
                    {user.email}
                  </p>
                </div>
              )}
              {user.isAdmin ? (
                <p className="m-0 mx-2 font-navbar">
                  Administrando{" "}
                  <span className="fw-bold">
                    {empresas.find((e) => e.value === company)?.label}
                  </span>
                </p>
              ) : (
                <>
                  <div className="d-flex align-items-center m-0 scroll-off">
                    <FontAwesomeIcon
                      className="mx-2 fs-6 font-navbar"
                      icon={faBuilding}
                    />
                    {(company == 10 || company == 60) && user.level >= 3 ? 
                      (
                        <p className="m-0 pe-3 custom-border-right font-navbar font-size-navbar">{`Región: ${
                          regions?.find((e) => e.value === sucursales?.find((e) => e.label.includes(user.sucursal)).codreg)
                          ?.value
                        } - ${
                          regions?.find((e) => e.value === sucursales?.find((e) => e.label.includes(user.sucursal)).codreg)
                          ?.label
                        }`}</p>   
                      ) : (
                        <p className="m-0 pe-3 custom-border-right font-navbar font-size-navbar">{`Sucursal: ${
                          sucursales?.find((e) => e.label.includes(user.sucursal))
                            ?.value
                        } - ${
                          sucursales?.find((e) => e.label.includes(user.sucursal))
                            ?.label
                        }`}</p>               
                      )
                    }
                  </div>
                  <div className="d-flex align-items-center m-0 scroll-off">
                    <FontAwesomeIcon
                      className="mx-2 fs-6 font-navbar"
                      icon={faAddressCard}
                    />
                    <p className="m-0 font-navbar font-size-navbar scroll-off">{`Legajo: ${user.vendor}`}</p>
                  </div>
                </>
              )}
              {user.isAdmin && (
                <Inputs
                  className={"mx-3"}
                  options={empresas}
                  value={company}
                  change={(e) => handleChange(e.value)}
                  type={"select"}
                />
              )}
            </div>
          </div>
          <div className="me-2 burger" onClick={handleBurger}>
            <FontAwesomeIcon className="fs-3 font-navbar" icon={faBars} />
          </div>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="font-navbar"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="fw-bold">Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {user.opcusu[0] !== "9" && (
            <>
              <p onClick={goToHome}>
                <FontAwesomeIcon className="me-2" icon={faHouse} /> Inicio
              </p>
              <p onClick={() => goTo("/policy")}>
                <FontAwesomeIcon className="me-2" icon={faBook} /> Consulta de
                pólizas
              </p>
            </>
          )}
          {/* {user.level >= adminLevel && <p onClick={() => goTo('/certificate')}><FontAwesomeIcon className="me-2" icon={faBook} /> Baja de certificados</p>} */}
          {user.level >= adminLevel && (
            <p onClick={() => goTo("/movtFiles")}>
              <FontAwesomeIcon className="me-2" icon={faBookOpenReader} /> Libro
              Rubricado de pólizas
            </p>
          )}
          <hr className="color-plan" />
          {user.opcusu[0] === "1" && company !== 4 && company !== 54 && (
            <>
              <p onClick={() => goTo("/sinister")}>
                <FontAwesomeIcon className="me-2" icon={faBookmark} /> Alta de
                Siniestro
              </p>
              <p onClick={() => goTo("/sinisters")}>
                <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} />{" "}
                Consulta de Siniestros
              </p>
              {user.level >= adminLevel && (
                <a
                  target={"_blank"}
                  rel="noreferrer"
                  href={`https://www.itdepsis.com.ar/7d156b/pm/libsinpm.htm?id=${user.id}`}
                  className="book-rubricado"
                >
                  <p className="font-navbar">
                    <FontAwesomeIcon className="me-2" icon={faBookOpenReader} />{" "}
                    Libro Rubricado de siniestros
                  </p>
                </a>
              )}
              <hr className="color-plan" />
            </>
          )}
          {user.opcusu[0] === "9" && (
            <p onClick={() => goTo("/sinisters")}>
              <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} />{" "}
              Consulta de Siniestros
            </p>
          )}
          {user.level === 10 && (
            <p onClick={() => goTo(`/adminStatics`)}>
              <FontAwesomeIcon className="me-2" icon={faChartColumn} />{" "}
              Estadísticas Admin
            </p>
          )}
          {user.level > 1 && (
            <p onClick={() => goTo(`/stcs/s`)}>
              <FontAwesomeIcon className="me-2" icon={faChartColumn} />{" "}
              Estadísticas por sucursal
            </p>
          )}
          {user.level > 2 && (
            <p onClick={() => goTo(`/stcs/r`)}>
              <FontAwesomeIcon className="me-2" icon={faChartColumn} />{" "}
              Estadísticas por región
            </p>
          )}
          {user.level > 3 && company !== 4 && company !== 54 && (
            <p onClick={() => goTo(`/stcs/z`)}>
              <FontAwesomeIcon className="me-2" icon={faChartColumn} />{" "}
              Estadísticas por zona
            </p>
          )}
          {user.level >= adminLevel && (
            <p onClick={() => goTo(`/stcs/a`)}>
              <FontAwesomeIcon className="me-2" icon={faChartColumn} />{" "}
              Estadísticas generales
            </p>
          )}
          {user.level > 1 && <hr className="color-plan" />}

          {company !== 4 && company !== 54 && user.level >= 5 && (
            <p onClick={() => goTo("/auditory")}>
              <FontAwesomeIcon
                className="me-2"
                icon={faMagnifyingGlassDollar}
              />{" "}
              Auditoria Fraude
            </p>
          )}
          {user.level >= adminLevel && (
            <>
              <p onClick={() => goTo("/users")}>
                <FontAwesomeIcon className="me-2" icon={faUsers} /> Usuarios
              </p>
              <p onClick={() => goTo("/sucursales")}>
                <FontAwesomeIcon className="me-2" icon={faMapLocationDot} />{" "}
                Sucursales
              </p>
              <p onClick={() => goTo("/regions")}>
                <FontAwesomeIcon className="me-2" icon={faMapLocationDot} />{" "}
                Regiones
              </p>
              {company !== 4 && company !== 54 && (
                <p onClick={() => goTo("/zones")}>
                  <FontAwesomeIcon className="me-2" icon={faMapLocationDot} />{" "}
                  Zonas
                </p>
              )}
              <hr className="color-plan" />
            </>
          )}

          {user.level > 1 && company === 4 && company === 54 && (
            <p onClick={() => goTo("/relocation")}>
              <FontAwesomeIcon className="me-2" icon={faCompass} /> Relocación
              Temporal
            </p>
          )}

          {user.isAdmin && (
            <>
              <p onClick={() => goTo("/settings")}>
                <FontAwesomeIcon className="me-2" icon={faGear} /> Configurar
                Fondo
              </p>
              <p onClick={() => goTo("/prices")}>
                <FontAwesomeIcon className="me-2" icon={faDollarSign} />{" "}
                Administrar precios
              </p>
              <p onClick={() => goTo("/syncFiles")}>
                <FontAwesomeIcon className="me-2" icon={faArrowsRotate} />{" "}
                Sincronización de Archivos
              </p>
              <p onClick={() => goTo("/newState")}>
                <FontAwesomeIcon className="me-2" icon={faFileArrowUp} />{" "}
                Generar Altas
              </p>
              <p onClick={() => goTo("/productsFiles")}>
                <FontAwesomeIcon className="me-2" icon={faFileArrowUp} /> Subir
                Constancias
              </p>
              <p onClick={() => goTo("/logs")}>
                <FontAwesomeIcon className="me-2" icon={faBookOpenReader} />{" "}
                Logs
              </p>
              <a
                target={"_blank"}
                rel="noreferrer"
                href={`https://www.itdepsis.com.ar/7d156b/pm/pmtablas.htm`}
                className="book-rubricado"
              >
                <p className="font-navbar">
                  <FontAwesomeIcon className="me-2" icon={faBookOpenReader} />{" "}
                  Administrar Tablas
                </p>
              </a>
            </>
          )}

          {user.level >= adminLevel && (
            <p onClick={() => goTo("/files")}>
              <FontAwesomeIcon className="me-2" icon={faFileArrowUp} /> Subir
              Archivos
            </p>
          )}

          {user.level >= 10 && (
            <a
              target={"_blank"}
              rel="noreferrer"
              href={`https://www.itdepsis.com.ar/7d156b/pm/conpmarc.htm?id=${user.id}`}
              className="book-rubricado"
            >
              <p className="font-navbar">
                <FontAwesomeIcon className="me-2" icon={faFileSignature} />{" "}
                Archivos procesados
              </p>
            </a>
          )}
          {user.level >= 10 && (
            <a
              target={"_blank"}
              rel="noreferrer"
              href={`https://www.itdepsis.com.ar/7d156b/pm/conpendientes.htm`}
              className="book-rubricado"
            >
              <p className="font-navbar">
                <FontAwesomeIcon className="me-2" icon={faFileSignature} />{" "}
                Ventas Online
              </p>
            </a>
          )}
          {user.level >= 10 && (
            <a
              target={"_blank"}
              rel="noreferrer"
              href={`https://www.itdepsis.com.ar/7d156b/pm/concantpm.htm?id=${user.id}`}
              className="book-rubricado"
            >
              <p className="font-navbar">
                <FontAwesomeIcon className="me-2" icon={faBook} /> Cantidad de
                certificados
              </p>
            </a>
          )}
          {/* <p onClick={() => goTo('/phones')}><FontAwesomeIcon className="me-2" icon={faPhone} /> Telefonos</p> */}

          {user.opcusu[0] !== "1" && <hr />}
          {user.level >= adminLevel && (
            <p onClick={() => goTo("/profile")}>
              <FontAwesomeIcon className="me-2" icon={faUser} /> Perfil
            </p>
          )}
          {company !== 4 && company !== 54 && (
            <p onClick={() => goTo("/version")}>
              <FontAwesomeIcon className="me-2" icon={faCode} /> Notas de la
              versión
            </p>
          )}
          {!user.token && (
            <p onClick={close}>
              <FontAwesomeIcon className="me-2" icon={faRightFromBracket} />{" "}
              Cerrar Sesión
            </p>
          )}
        </Offcanvas.Body>
      </Offcanvas>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> ¡Aviso!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>{bodyModal}</Modal.Footer>
      </Modal>
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: state.mainReducer.user,
    nameCompany: state.mainReducer.nameCompany,
    empresas: state.mainReducer.empresas,
    company: state.mainReducer.company,
    titularData: state.mainReducer.titularData,
    homeData: state.mainReducer.homeData,
    payMethod: state.mainReducer.payMethod,
    vehicleData: state.mainReducer.vehicleData,
    sucursales: state.mainReducer.sucursales,
    regions: state.mainReducer.regions,
    infoCompany: state.mainReducer.infoCompany,
  };
}

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
